// @flow
import * as React from 'react'
import useStyles from './styles'
import {
  Button,
  CircularProgress,
  TextField,
  Typography,
} from '@material-ui/core'
declare type Props = {
  values: LoginValues,
  touched: LoginTouched,
  errors: LoginErrors,
  handleFieldChange: (string, string) => void,
  handleResetPassword: (Object) => Promise<void>,
  isLoading: boolean,
  isValid: boolean,
  submitError: Error | null,
}
const ResetPasswordForm = ({
  values,
  touched,
  errors,
  handleFieldChange,
  handleResetPassword,
  isLoading,
  isValid,
  submitError,
}: Props) => {
  const classes = useStyles()

  return (
    <form className={classes.form} onSubmit={handleResetPassword}>
      <img alt="CP" className={classes.logoImage} src="/images/logos/CP.png" />
      <Typography className={classes.title} gutterBottom variant="h2">
        Password Reset Required
      </Typography>
      <Typography variant="body2">
        The password you entered was a temporary password, and must be reset for
        security purposes. Please enter your new password below to continue.
      </Typography>

      <div className={classes.fields}>
        <TextField
          autoFocus
          id="sign-in-new-password"
          fullWidth
          className={classes.textField}
          label="New Password"
          name="newPassword"
          onChange={(event) =>
            handleFieldChange('newPassword', event.target.value)
          }
          type="password"
          value={values.newPassword}
          variant="outlined"
        />
        {touched.newPassword &&
          errors.newPassword &&
          errors.newPassword.length && (
            <Typography className={classes.fieldError} variant="body2">
              {errors.newPassword[0]}
            </Typography>
          )}
        <TextField
          id="sign-in-password"
          fullWidth
          className={classes.textField}
          label="Confirm Password"
          name="confirmPassword"
          onChange={(event) =>
            handleFieldChange('confirmPassword', event.target.value)
          }
          type="password"
          value={values.confirmPassword}
          variant="outlined"
        />
        {touched.confirmPassword &&
          errors.confirmPassword &&
          errors.confirmPassword.length && (
            <Typography className={classes.fieldError} variant="body2">
              {errors.confirmPassword[0]}
            </Typography>
          )}
      </div>
      {submitError && (
        <Typography className={classes.submitError} variant="body2">
          {submitError.message}
        </Typography>
      )}
      {
        <Button
          type="submit"
          className={classes.signInButton}
          color="primary"
          disabled={!isValid || isLoading}
          size="large"
          variant="contained"
        >
          {isLoading ? (
            <CircularProgress size={25} className={classes.progress} />
          ) : (
            'Reset Password &amp; Sign In'
          )}
        </Button>
      }
    </form>
  )
}

export default ResetPasswordForm
